import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-time-axis",
  "use": "app-icon-simple-time-axis-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"app-icon-simple-time-axis\"><g fill-rule=\"evenodd\"><path fill=\"none\" d=\"M.5 0h16v16H.5z\" /><path d=\"M8.5 1a7 7 0 110 14 7 7 0 010-14zm0 1a6 6 0 100 12 6 6 0 000-12zm-.016 2.167a.5.5 0 01.495.406l.008.09.023 3.128 1.845 1.857a.5.5 0 01.056.638l-.059.069a.5.5 0 01-.638.056l-.069-.059-1.987-2a.5.5 0 01-.135-.252l-.01-.096-.026-3.334a.5.5 0 01.497-.503z\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol